import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import _ from 'lodash';

import Layout from '../../components/Layout';
import BoxQueues from '../../components/BoxQueues';
import BoxAgents from '../../components/BoxAgents';
import Paineis from '../../components/Paineis';

import { listenerQueues } from '../../actions/QueuesActions';


class Dasboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            answered: 0,
            slQueuesValue: [],
            slQueuesOptions: [],
            filter: [],
            waitingLength: 0
        }

        this.onChangeQueueSelect = this.onChangeQueueSelect.bind(this);
    }

    async componentDidMount() {
        let queues = this.props.auth.queuesAvailable.map( q => ({ value: q.extension, label: `[${q.extension}] ${q.name}` })) ;
        let filter = this.props.auth.queuesAvailable.map( q => q.extension ) ;
        this.setState({
            slQueuesValue: queues,
            slQueuesOptions: queues,
            filter,
        })
        
    }

    onChangeQueueSelect(value, event) {
        let filter = value ? value.map( q => q.value ) : [];

        this.setState({ 
            slQueuesValue: value,
            filter
        });
    }

    _waitingCount = waitingLength => {
        this.setState({ waitingLength })
    }

    render() {

        const abandonFilter = _.filter(this.props.abandoned, val => this.state.filter.indexOf(parseInt(val.queue)) >= 0 );   
        const completedFilter = _.filter(this.props.completed, val => this.state.filter.indexOf(parseInt(val.queue)) >= 0 );   
        const connectedFilter = _.filter(this.props.connected, val => this.state.filter.indexOf(parseInt(val.queue)) >= 0 );   
        const qtdAgentesLogados = _.filter(this.props.qtdAgentesLogados, (item) => {
            const queues = item.queues;
            return _.some(this.state.filter, (queueNumber) => queues.hasOwnProperty(queueNumber.toString()));
        });

        const qtdAgentesDisponiveis = _.filter(this.props.qtdAgentesDisponiveis, (item) => {
            const queues = item.queues;
            return _.some(this.state.filter, (queueNumber) => queues.hasOwnProperty(queueNumber.toString()));
        });
        const qtdAgentesEmPause = _.filter(this.props.qtdAgentesEmPause, (item) => {
            const queues = item.queues;
            return _.some(this.state.filter, (queueNumber) => queues.hasOwnProperty(queueNumber.toString()));
        });

        return (
            <Layout>
                <section className="content-header">
                    <h1>
                        Dashboard
                    </h1>
                    <ol className="breadcrumb">
                        <li><a href="#"  onClick={() => {}}><i className="fa fa-dashboard"></i> Home</a></li>
                        <li >Supervisor</li>
                        <li className="active">Dasboard</li>
                    </ol>
                </section>

                <section className="content">
                    <div className="row">
                        <div className="box">
                            <div className="box-body">
                                <div className="col-md-12">
                                    <form >
                                        <div className="col-sm-10 offset-md-1">
                                            <label htmlFor="inputPassword3" className="col-sm-2 control-label">Filas</label>

                                            <Select
                                                value={this.state.slQueuesValue}  
                                                isMulti
                                                options={this.state.slQueuesOptions}
                                                isClearable={true}
                                                onChange={this.onChangeQueueSelect}
                                            />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <Paineis 
                            size="col-md-3 col-sm-6 col-xs-12"
                            className="info-box-icon bg-aqua"
                            icon="fa fa-smile-o"
                            title="Atendidas"
                            value={completedFilter.length}
                            tooltip="Chamadas atendidas com sucesso"
                            />

                        <Paineis    
                            size="col-md-3 col-sm-6 col-xs-12"
                            className="info-box-icon bg-red"
                            icon="fa fa-frown-o"
                            title="Abandonos/ Transferências"
                            value={abandonFilter.length}
                            tooltip="Abandonos e Transferências na Fila: Este item de informação inclui registros de chamadas que não foram atendidas por um agente, representando os abandonos de clientes, bem como casos em que as chamadas foram transferidas (Transbordo) na fila e também não foram atendidas por um agente. Ambos os cenários são considerados como 'não atendidos' para fins de registro e análise"
                            />
  
                        <Paineis 
                            size="col-md-3 col-sm-6 col-xs-12"
                            className="info-box-icon bg-yellow"
                            icon="fa fa-meh-o"
                            title="Em filas"
                            value={this.state.waitingLength}
                            tooltip="Ligações em fila aguardando atendimento"
                            />

                        <Paineis 
                            size="col-md-3 col-sm-6 col-xs-12"
                            className="info-box-icon bg-green"
                            icon="fa fa-reorder"
                            title="Recebidas"
                            value={completedFilter.length + abandonFilter.length}
                            tooltip="⁠Total de chamadas recebidas no dia"
                            />
                    </div>
 
                    <div className="row">
                        <Paineis 
                            size="col-md-3 col-sm-6 col-xs-12"
                            className="info-box-icon  bg-aqua"
                            icon="ion ion-ios-people-outline"
                            title="Logados"
                            value={qtdAgentesLogados.length}
                            tooltip="Total de agentes logados (Disponivel + Atendendo + Pausas)"
                            />

                        <Paineis 
                            size="col-md-3 col-sm-6 col-xs-12"
                            className="info-box-icon bg-green"
                            icon="fa fa-play"
                            title="Disponiveis"
                            value={qtdAgentesDisponiveis.length}
                            tooltip="Agentes logados e disponíveis"
                            />

                        <Paineis 
                            size="col-md-3 col-sm-6 col-xs-12"
                            className="info-box-icon bg-yellow"
                            icon="fa fa-pause"
                            title="Em Pausa"
                            value={qtdAgentesEmPause.length}
                            tooltip="Agentes em pausa sem possibilidade de atendimento"
                            />
                        <Paineis 
                            size="col-md-3 col-sm-6 col-xs-12"
                            className="info-box-icon bg-green"
                            icon="fa fa-phone"
                            title="Em Atendimento"
                            value={connectedFilter.length}
                            tooltip="Agentes que estão em atendimento"
                            />
                    </div>

                    <div className="row">
                        <div className="col-md-4">
                            <BoxQueues 
                                queuesListener={this.state.filter}
                                waitingCount={ this._waitingCount }
                                />
                        </div>
                        <div className="col-md-8">
                            <BoxAgents queuesListener={this.state.filter}/>
                        </div>
                        
                    </div>
                </section>
            </Layout>
        );
    }
}

const mapStateToProps = state => {

    const qtdAgentesLogados = _.filter(state.AgentesReducer.agents, agent => agent?.status?.c_pauses_id >= 1);
    const qtdAgentesDisponiveis = _.filter(state.AgentesReducer.agents, agent => agent?.status?.c_pauses_id === 1);
    const qtdAgentesEmPause = _.filter(state.AgentesReducer.agents, agent => agent?.status?.c_pauses_id > 1);
    const qtdAgentesEmAtendimento = _.filter(state.AgentesReducer.agents, agent => agent?.awnsering?.number > 1);

    return ({
        auth: state.AutenticacaoReducer,
        abandoned: state.QueuesReducer.abandoned,
        completed: state.QueuesReducer.completed,
        connected: state.QueuesReducer.connected,
        qtdAgentesLogados,
        qtdAgentesDisponiveis,
        qtdAgentesEmPause,
        qtdAgentesEmAtendimento,
    })
}
  
export default connect(mapStateToProps, {
    listenerQueues, 
})(Dasboard);
